import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const rydFinancialSection: MenuItem[] = [
  {
    headTitle1: 'ryd Financial',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
  },
  {
    path: '/accounting/overview',
    title: 'Overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
  },
  {
    title: 'Invoicing',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/accounting/invoicing/failed-requests',
        title: 'Invoicing Failed Requests',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/invoicing/data-consistency-check',
        title: 'Data Consistency Check',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/invoicing/odoo-order-monitor',
        title: 'Odoo Order Monitor',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/invoicing/invoice-cancellation',
        title: 'Invoice Cancellation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
      },
      {
        path: '/accounting/invoicing/invoice-modification',
        title: 'Invoice Modification',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
      },
      {
        path: '/accounting/invoicing/e-invoice-validation',
        title: 'E-Invoice Validation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/invoicing/e-invoice-repair',
        title: 'E-Invoice Repair',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
  {
    title: 'Reporting',
    icon: 'stroke-reports-analytics',
    iconf: 'fill-reports-analytics',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.accountingAdmin],
    children: [
      {
        path: '/accounting/reporting/b2c-invoices',
        title: 'B2C Invoices',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.accountingAdmin],
      },
    ],
  },
  {
    title: 'Partner Reconciliation',
    icon: 'stroke-project',
    iconf: 'fill-project',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.accountingAdmin],
    children: [
      {
        path: '/accounting/partner-file-hub/q8',
        title: 'Q8 Reconciliation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.accountingAdmin],
      },
      {
        path: '/accounting/partner-file-hub/tamoil',
        title: 'Tamoil Italy',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.accountingAdmin],
      },
      {
        path: '/accounting/eg',
        title: 'EG Reconciliation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.accountingAdmin],
      },
      {
        path: '/accounting/list-price-reports',
        title: 'List Price Reports',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.accountingAdmin],
      },
    ],
  },
  {
    title: 'Partner Fiscal Monitoring',
    icon: 'stroke-data-exchange-monitoring',
    iconf: 'fill-data-exchange-monitoring',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/accounting/fiscal-monitoring/poland',
        title: 'Poland (Exorigo-Upos)',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/fiscal-monitoring/poland/resend',
        // The per-row resend editor lives under /outbound/<odooId>/resend — highlight this
        // entry there too, since that page has no menu item of its own.
        activePathPrefixes: ['/accounting/fiscal-monitoring/poland/outbound/*/resend'],
        title: 'Poland Fiscal Resend',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/accounting/fiscal-monitoring/moloni',
        title: 'Moloni (Portugal)',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
    ],
  },
];
